import { render, staticRenderFns } from "./ModelProduct.vue?vue&type=template&id=de341d7a&scoped=true"
import script from "./ModelProduct.vue?vue&type=script&lang=ts"
export * from "./ModelProduct.vue?vue&type=script&lang=ts"
import style0 from "./ModelProduct.vue?vue&type=style&index=0&id=de341d7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de341d7a",
  null
  
)

export default component.exports